import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <h3>MAB Jewels (Manoj Abhushan Bhandar, Rajasthan)</h3>
            <p>Premium Jewellery Collection</p>
          </div>
          <div className="footer-description">
            <p>MAB Jewels is built on the legacy of Manoj Abhushan Bhandar, crafting certified gold and fine jewellery that blends tradition with modern Indian elegance.</p>
          </div>
          <div className="footer-social" style={{ marginTop: '20px' }}>
            <div className="social-links-minimal">
              <a href="https://www.instagram.com/jewelsmab/" target="_blank" rel="noopener noreferrer" className="social-icon-btn instagram" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61585088147958" target="_blank" rel="noopener noreferrer" className="social-icon-btn facebook" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
              </a>
              <a href="https://youtube.com/@MABJewels" target="_blank" rel="noopener noreferrer" className="social-icon-btn youtube" aria-label="YouTube">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h4>Contact Information</h4>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-icon">
                <svg className="phone-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </svg>
              </span>
              <span>+91 9414817620</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">
                <svg className="email-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
              </span>
              <span>mabjewels.store@gmail.com</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">
                <svg className="location-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                </svg>
              </span>
              <span>MAB Jewels, Rajasthan</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">
                <svg className="location-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
                </svg>
              </span>
              <span>GSTIN: 08BPIPS2564F1ZM</span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/jewellery">Jewellery Collection</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/blog">Jewellery Blog</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Customer Care</h4>
          <ul className="footer-links">
            <li><a href="/verify-huid" style={{ color: '#d4af37', fontWeight: '600' }}>🔍 Verify Your Gold (HUID Check)</a></li>
            <li><a href="/transparency">Price Breakup & Making Charges</a></li>
            <li><a href="/bis-hallmarking-guide">BIS Hallmarking Guide</a></li>
            <li><a href="/jewellery-care-guide">Jewellery Care Guide</a></li>
            <li><a href="/return-exchange-policy">Return & Exchange</a></li>
          </ul>
          <div className="trust-badges">
            <div className="trust-badge">
              <span>BIS Hallmark</span>
            </div>
            <div className="trust-badge">
              <span>100% Certified</span>
            </div>
          </div>
        </div>


      </div>

      {/* SEO Internal Linking Section */}
      <div className="footer-seo-links" style={{ borderTop: '1px solid #333', marginTop: '40px', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ color: '#888', marginBottom: '10px', fontSize: '0.9rem' }}>Popular Searches:</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <a href="/gold-jewellery-jodhpur" style={{ color: '#aaa', textDecoration: 'none', fontSize: '0.85rem' }}>Gold Jewellery in Jodhpur</a>
          <span style={{ color: '#444' }}>|</span>
          <a href="/wedding-jewellery-rajasthan" style={{ color: '#aaa', textDecoration: 'none', fontSize: '0.85rem' }}>Wedding Jewellery in Rajasthan</a>
          <span style={{ color: '#444' }}>|</span>
          <a href="/gold-rate-jodhpur" style={{ color: '#aaa', textDecoration: 'none', fontSize: '0.85rem' }}>Today Gold Rate in Jodhpur</a>
          <span style={{ color: '#444' }}>|</span>
          <a href="/verify-huid" style={{ color: '#aaa', textDecoration: 'none', fontSize: '0.85rem' }}>Verify HUID Online</a>
          <span style={{ color: '#444' }}>|</span>
          <a href="/blog" style={{ color: '#aaa', textDecoration: 'none', fontSize: '0.85rem' }}>Jewellery Insights Blog</a>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {new Date().getFullYear()} MAB Jewels. All rights reserved.</p>
          <div style={{ marginTop: '5px', fontSize: '0.85rem', color: '#888' }}>
            Digital Platform Engineering by Harshvardhan Soni
          </div>
          <div className="footer-bottom-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
